module.exports = "<div class=\"wrapper wrapper-content animated fadeInUp\"> <div class=ibox> <breadcrumb></breadcrumb> <customizable-view> <div class=mod-tabs> <uib-tabset active=0> <uib-tab index=0 heading=车辆种类> <vehicle-info></vehicle-info> </uib-tab> <uib-tab index=1 heading=产地> <vehicle-producing-area></vehicle-producing-area> </uib-tab> <uib-tab index=2 heading=生产企业名称> <vehicle-producer></vehicle-producer> </uib-tab> </uib-tabset> </div> </customizable-view> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/system/basedata/vehicleInfo/view/vehicleInfoTab.html
// module id = LDxV
// module chunks = 0